import React, { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import * as S from './AdFormLayout.styles';
import { LayoutAppearance } from './AdFormLayout.types';
import { CloseIcon } from '@/components/UI/Icons/Icons';
import useScreenSize from '@/hooks/useScreenSize';
import { Header } from '@/components/Header';

interface Props {
  onClose?: () => void;
  appearance?: LayoutAppearance;
  onReset?: () => void;
  mode?: 'create' | 'edit';
}

export const AdFormLayout: FC<PropsWithChildren<Props>> = ({
  children,
  onClose,
  onReset,
  appearance = 'default',
  mode = 'create',
}) => {
  const { isLarge } = useScreenSize();
  const { t } = useTranslation();
  const {
    formState: { isDirty },
  } = useFormContext();

  const isCreateMode = mode === 'create';

  const title = isCreateMode
    ? t('pages.new_ad.new_ad')
    : t('pages.edit_ad.edit_ad');

  return (
    <S.Wrapper
      {...(!isLarge && isCreateMode && { className: 'layout_ads_new' })}
    >
      <S.AdFormPageTopControls>
        <Header
          title={title}
          rightAction={
            isCreateMode && (
              <S.ResetButton onClick={onReset} disabled={!isDirty}>
                {t('common.reset')}
              </S.ResetButton>
            )
          }
        />
      </S.AdFormPageTopControls>
      <S.Body>
        <S.Card $appearance={appearance}>
          {isLarge && (
            <S.CardHead>
              <S.CardTitle $appearance={appearance}>{title}</S.CardTitle>
              {isCreateMode && (
                <>
                  {appearance === 'form' ? (
                    <S.ResetButton disabled={!isDirty} onClick={onReset}>
                      {t('common.reset')}
                    </S.ResetButton>
                  ) : (
                    <S.CardCloseButton
                      data-testid="card-close-button"
                      appearance="transparent"
                      hasPadding={false}
                      onClick={onClose}
                    >
                      <CloseIcon width={20} height={20} />
                    </S.CardCloseButton>
                  )}
                </>
              )}
            </S.CardHead>
          )}
          {children}
        </S.Card>
      </S.Body>
    </S.Wrapper>
  );
};
